import React from "react";
import { Tooltip } from "antd";
import { motion } from "framer-motion";
import { SettingOutlined } from "@ant-design/icons";
import authService from "../../../../api/auth/authService";

const SettingsLauncher: React.FC = () => {
  const target = (process.env.REACT_APP_MASTERS_URL || "").replace(/\/+$/, "");

  const handleClick = async () => {
    if (!target) return;
    // One-time handoff code lets Masters start this user's session even when it
    // is served from a different origin (deployed subdomains). Masters `/`
    // always renders Login, so the entry point is /home.
    try {
      const data = await authService.createSessionHandoff();
      if (data?.status && data?.code) {
        window.open(`${target}/home#handoff=${data.code}`, "_blank", "noopener,noreferrer");
        return;
      }
    } catch (err) {
      console.error("Masters handoff failed:", err);
    }
    window.open(`${target}/home`, "_blank", "noopener,noreferrer");
  };

  if (!target) return null;

  return (
    <Tooltip title="Settings (Masters)" placement="bottom">
      <motion.div
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
        onClick={handleClick}
        style={{
          cursor: "pointer",
          display: "inline-flex",
          alignItems: "center",
        }}
      >
        <SettingOutlined style={{ fontSize: 18 }} />
      </motion.div>
    </Tooltip>
  );
};

export default SettingsLauncher;
